import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
} from '@mui/material';
import { useGlobal } from '../contexts/GlobalContext';

const AuthApiKey = ({ open, onClose }) => {
  const {
    apiKey,
    accountId,
    updateApiKey,
    updateAccountId,
  } = useGlobal();
  const [tempApiKey, setTempApiKey] = useState(apiKey);
  const [tempAccountId, setTempAccountId] = useState(
    accountId
  );

  useEffect(() => {
    if (open) {
      setTempApiKey(apiKey);
      setTempAccountId(accountId);
    }
  }, [open, apiKey, accountId]);

  const handleSave = () => {
    updateApiKey(tempApiKey);
    updateAccountId(tempAccountId);
    onClose();
  };

  const handleCancel = () => {
    setTempApiKey(apiKey);
    setTempAccountId(accountId);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleCancel} maxWidth="sm" fullWidth>
      <DialogTitle>API Key Authentication</DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 1 }}>
          <TextField
            autoFocus
            margin="dense"
            label="API Key"
            type="text"
            fullWidth
            variant="outlined"
            value={tempApiKey}
            onChange={(e) => setTempApiKey(e.target.value)}
            helperText="Enter your API key to authenticate requests"
            sx={{ mb: 2 }}
          />
          <TextField
            margin="dense"
            label="Account ID"
            type="text"
            fullWidth
            variant="outlined"
            value={tempAccountId}
            onChange={(e) => setTempAccountId(e.target.value)}
            helperText="Console account ID"
            sx={{ mb: 2 }}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel}>Cancel</Button>
        <Button onClick={handleSave} variant="contained">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AuthApiKey;

